import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { z } from "zod";
import {
  HeaderRoot,
  HeaderButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { OneLivExperiencesForm } from "@/components/oneliv/oneliv-experiences-form";

import type { JSX } from "react";

const GetOneLivUserExperiences = graphql(`
  query GetOneLivUserExperiences {
    locus_membro {
      ...OneLivExperiencesFormFragment
    }
  }
`);

const oneLivExperiencesPageSearchSchema = z.object({
  action: z.string().optional().catch(""),
});

const OneLivExperiences = (): JSX.Element => {
  const query = useGraphQL(GetOneLivUserExperiences);

  const { data } = query;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Experiências" align="center" />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...query}>
          {data ? <OneLivExperiencesForm data={data.locus_membro} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/oneliv/experiences")({
  component: OneLivExperiences,
  validateSearch: oneLivExperiencesPageSearchSchema,
});
